
<template>
<div>
  <img id="chatIcon" class="chatbox-container" src="../assets/robot2.png" height="70" @click="toggleChatbot()">

<div class="chatbox-container chat-bar-collapsible">
  
  <button id="chat-button" type="button" class="collapsible" @click="toggleChatbot()" style="display:none">
    <!--<b-icon icon="chat-dots" variant=""></b-icon> BijuleeSewa Bot ! Chat with me  --> 
    <img src="@/assets/robot2.png" alt="APDCLBOT" class="apdclbot-img" /> BijuleeSewa Bot ! Chat with me   
     
    <b-icon style="float: right;" @click="clearChat()" icon="x-square" font-scale="1.2"></b-icon> 
    <b-icon style="float: right; margin-right:10px;" icon="arrow-down-left-square" font-scale="1.2"></b-icon>
   </button>
<div class="container" id="chatbotContatiner" >
 

<div class="messageBox mt-8"  ref="chatbox">
  <!-- <div id="GraphContainer"></div> -->
  
  <div v-for="(message, index) in messages" :key="index">
    <span>
    <div :class="message.from == 'user' ? 'messageFromUser' : 'messageFromApdcl'">
      <div v-if="message.from === 'user'" class="userAvatar">
        <!--<i class="fas fa-user">User</i>-->


        <b-icon icon="person-circle" font-scale="2" variant="dark" class="bot-icon"></b-icon>

      </div>
      <div v-else class="apdclAvatar">
        
        <img src="@/assets/robot2.png" alt="APDCLBOT" class="apdclbot-img" />
      
      </div>
      <div :class="message.from == 'user' ? 'userMessageWrapper' : 'ApdclMessageWrapper'">
        <div :class="message.from == 'user' ? 'userMessageContent' : 'ApdclMessageContent'">
            <!-- {{ message.data }} -->
           <p v-html="message.data"></p>
        </div>
        <p class="timeClass" v-html="message.time"></p>
      </div>
    </div>
  </span>
  </div>

</div>

<div class="inputContainer">
  <b-icon
    icon="three-dots"
    animation="cylon"
    font-scale="4"
    v-if="currentMessage.trim() !== ''" class="mr-2"
  ></b-icon>
 
  <input
    v-model="currentMessage"
    type="text"
    id="userInputText"
    class="messageInput"
    placeholder="Type Here..."
    @keyup.enter="sendMessage(currentMessage)"
    style="font-size:0.9rem !important"
  />
  <button
    @click="sendMessage(currentMessage)"
    class="askButton"
  >
    Send
  </button>
</div>
</div>
</div>
</div>
</template>


<script>
import Chart from 'chart.js';
import axios from 'axios';
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);


import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

var consNo = "";
var i=1;
var d = new Date();
var dateTime = d.toString().split("GMT")[0];

export default {
  name: 'ChatBox',
  data() {
    return {
      currentMessage: '',
      lastMessage:'',
      isBotTyping: false,
      typingIndex: null,
      messages: [{
      from: 'Apdcl',
      data: "Hi, I am BijuleeSewa bot,<br> Please enter your 12 digit consumer number",
     
      //data: "Hi there! How can I assist you today?",
      time: dateTime
      //data: '<div id="GraphContainer"></div>'
  }],
  menu:{},
  fetchMsg:{
    defaultMsg:"Fetching Your data. Please wait.",
    bill:"I have the latest bill information available with me. Please wait a moment while I retrieve your information.",
    payment:"I have the latest payment information available with me. Please wait a moment while I retrieve your information.",
    balance:"Please wait a moment while I retrieve your balance.",
    recharge:"I have the latest recharge information available with me. Please wait a moment while I retrieve your information.",
    statement:"I have the last month prepaid statement available with me. Please wait a moment while I retrieve your information.",
    consumptionHistory:"I have the last seven(7) days consumption history with me. Please wait a moment while I retrieve your information.",
    balanceHistory:"I have the last seven(7) days balance history with me. Please wait a moment while I retrieve your information.",
  }
  
    };
  },
  methods: {
    clearChat()
    {
      var d = new Date();
      var dateTime = d.toString().split("GMT")[0];
      this.messages=[{
      from: 'Apdcl',
      // data: "Hi, I am BijuleeSewa bot, Please enter your 12 digit consumer number ",
      data: "Hi there! How can I assist you today?",
      time: dateTime
      }];
    },
    backToMenu()
    {
      this.messages.push(this.menu);
      this.$nextTick(() => {this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;});
    },

    toggleChatbot(){
       document.getElementById("chatbotContatiner").style.transition = "all 1s";
        var content =  document.getElementById("chatbotContatiner");
        console.log("content.style.maxHeight::::"+content.style.maxHeight)
        if (content.style.maxHeight=="0px" || content.style.maxHeight=="") {
          document.getElementById("chat-button").style.display="block";
          document.getElementById("chatIcon").style.display="none";
          content.style.maxHeight = "600px";
          content.style.maxWidth = "600px";
        } else {
            content.style.maxHeight = "0px";
            content.style.maxWidth = "0px";
            document.getElementById("chat-button").style.display="none";
            document.getElementById("chatIcon").style.display="block";
        }
  },
  fetchAnimation(msg)
  {
    this.messages.push({
        from: 'Apdcl',
       // data: msg+" <br> <img src='../assets/loading-2.gif' style='width:80px'>",
        data: msg+" <br> <b-icon icon='three-dots' animation='cylon' font-scale='4'></b-icon>",
        time:dateTime
        });
        this.currentMessage='';
        this.$nextTick(() => {this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;});
        setTimeout(function() {
          var sp =""
          document.getElementById("chatbotContatiner").querySelectorAll('span').forEach(element => {
          //console.log (element);
          sp = element;
        });
        console.log(sp);
        sp.remove();
        }, 2000);
  },
 
   sendMessage(message) {
      var otpReq ="";
      var otpValidate="";
      var otp= "";
      var mobile= "";
      var email= "";
      var applNo= "";
      var botMsg=-"";
      var d = new Date();
      var dateTime = d.toString().split("GMT")[0];
      //console.log("msg: "+JSON.stringify(this.messages));
      if(this.currentMessage=='')
        {
          this.$bvToast.toast('Please Type Something!', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return;
        }
      this.messages.push({
        from: 'user',
        data: message,
        time:dateTime
      });
      
      console.log("lastMessage 1:::: "+this.lastMessage);
      if(this.currentMessage.length == 12)
      {
        consNo = this.currentMessage;
        otpReq ="Y";
        otpValidate="";
        otp= "";
      }
      else if(this.currentMessage.length == 6)
      {
        consNo = consNo;
        otpReq ="";
        otpValidate= "Y";
        otp= this.currentMessage;
      }
      else if(this.currentMessage.search(/menu/i)>=0)
      {
        this.messages.push(this.menu);
        this.currentMessage='';
        this.$nextTick(() => {this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;});
        return;
      }
      else if(this.currentMessage.search(/exit/i)>=0)
      {
        this.messages.push({
        from: 'Apdcl',
        data: "Sure, if you ever need assistance in the future, feel free to reach out. Have a great day!", 
        time:dateTime
      });
      this.messages.push({
        from: 'Apdcl',
        data: "Exiting the Chat", 
        time:dateTime
      });
      this.currentMessage='';
        setTimeout(() => {
        this.clearChat();
        this.menu={};
        }, 2000);
        this.$nextTick(() => {this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;});
        return;
      }
      else if(this.lastMessage == "Update mobile number")
      {
        consNo = consNo;
        mobile=message;
        botMsg=this.lastMessage;
      }
      else if(this.lastMessage == "Update email id")
      {
        consNo = consNo;
        email=message;
        botMsg=this.lastMessage;
      }
      else if(this.lastMessage == "Check application status")
      {
        consNo = consNo;
        applNo=message;
        botMsg=this.lastMessage;
      }
  
      
      else{
         
          botMsg= this.currentMessage;
       
      }
     
   
let dataTosend = JSON.stringify({
    "consNo": consNo,
    "otpReq": otpReq,
    "otpValidate":otpValidate,
    "otp": otp,
    "isMenu": "",
    "mobNo":mobile,
    "email":email,
    "applNo":applNo,
    "botMsg": botMsg
  });

let config = {
  method: 'post',
  url: 'https://uat.apdclrms.com/bot/RestAPI/getBotResponse',
  headers: { 
    'Content-Type': 'application/json'
  },
  data : dataTosend
};
var parent = this;

this.fetchAnimation(this.fetchMsg.defaultMsg);

setTimeout(function() {
axios.request(config)
.then((response) => {
  console.log((response.data));
  d = new Date();
  dateTime = d.toString().split("GMT")[0];
  if(response.data.status=="success" && response.data.otpGenerated=="Y" )
  {
    parent.messages.push({
        from: 'Apdcl',
        data: "Hello, "+response.data.consName+"<br> Please enter 6 digit OTP received in your mobile number", 
        time:dateTime
      });
  }
  else if(response.data.status=="fail" && response.data.otpGenerated=="N" )
  {
    parent.messages.push({
        from: 'Apdcl',
        data:response.data.error, 
        time:dateTime
      });
  }
  else if(response.data.status=="success" && response.data.responseType=="botResponse" )
  {
    parent.messages.push({
        from: 'Apdcl',
        data: "<span style='color: #df5d00;font-size:1rem'>"+response.data.msg+"</span>", 
        time:dateTime
      });
    }

  else if(response.data.status=="success" && response.data.otpValidated=="Y" && response.data.responseType=="menu")
  {
    var res = response.data.consDetails.split(",");
    var msg="";
    msg+= "<table><tr><td style='color: grey;'>Type </<td><td> : <span id='connType' style='color: #e67b1cbd;font-weight: 600;'>"+res[0]+"</span></<td><td style='padding-left:10px;color:grey'>Load </td><td> : <span  id='load' style='color: #e67b1cbd;font-weight: 600;'>"+res[1]+"</span></td></tr>";
    msg+= "<tr><td style='color: grey;'>Meter No </td><td> : <span  id='meterNo' style='color: #e67b1cbd;font-weight: 600;'>"+res[3]+"</span></td><td  style='padding-left:10px;color:grey'>Status </td><td> : <span  id='connStatus' style='color: #e67b1cbd;font-weight: 600;'>"+res[2]+"</span> </td></tr></table>";
    msg+="<hr> Welcome to our service! Please select from the below options: <br>"
    var btn=response.data.msg.split(",");
    for(var i=0;i<btn.length;i++)
    {
      msg+=" <button class='btn btn-outline-info' style='margin-top: 5px !important;border-radius: 25px !important; box-shadow: 1px 1px 1px 0px !important;' onclick='getResponse(\""+btn[i]+"\")'>"+btn[i]+"</button>";
       
    }
    parent.messages.push({
        from: 'Apdcl',
        data: msg,
        time:dateTime
      });
      parent.menu={
        from: 'Apdcl',
        data: msg, 
        
      };
      document.getElementById("userInputText").placeholder = 'Type "MENU" to go back to main menu or “EXIT” to exit the chat';
    }
      parent.$nextTick(() => {parent.$refs.chatbox.scrollTop = parent.$refs.chatbox.scrollHeight;});
    })
    .catch((error) => {
      console.log(error);
    });
  },2000);

    this.currentMessage='';
  this.$nextTick(() => {this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;});
    },

  
 getResponse(message){      
      var otpReq ="";
      var otpValidate="";
      var otp= "";
      this.currentMessage=message;
      var d = new Date();
      var dateTime = d.toString().split("GMT")[0];
      this.messages.push({
        from: 'user',
        data: message,
        time:dateTime
      });
      // console.log("Poped msg 1:::: "+(this.messages.pop().data))
      // console.log("lastMessage 2:::: "+this.lastMessage)
  if(message=="Update mobile number" )
    {
      this.lastMessage = message;
      this.messages.push({
        from: 'Apdcl',
        data: "Please Enter your mobile number", 
        time:dateTime
      });
      this.currentMessage='';
      this.$nextTick(() => {this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;});
      return;
     
    }
    else if(message=="Update email id" )
    {
      this.lastMessage = message;
      this.messages.push({
        from: 'Apdcl',
        data: "Please Enter your email id",
        time:dateTime 
      });

      this.currentMessage='';
      this.$nextTick(() => {this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;});
      return;
     
    }
    else if(message=="Check application status" )
    {
      this.lastMessage = message;
    this.messages.push({
        from: 'Apdcl',
        data: "Please Enter your application number", 
        time:dateTime
      });
      this.currentMessage='';
      this.$nextTick(() => {this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;});
      return;
     
    }
    else if(message=="Register complain" )
    {
      
      this.currentMessage=message;
     
      window.open('https://www.bijuleebandhu.com/', '_blank');
      this.$nextTick(() => {this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;});
      return;
     
    }

  let dataTosend = JSON.stringify({
    "consNo": consNo,
    "otpReq": otpReq,
    "otpValidate":otpValidate,
    "otp": otp,
    "isMenu": "",
    "mobNo":"",
    "email":"",
    "applNo":"",
    "botMsg": message
  });

  let config = {
    method: 'post',
    url: 'https://uat.apdclrms.com/bot/RestAPI/getBotResponse',
    headers: { 
      'Content-Type': 'application/json'
    },
    data : dataTosend
  };

  //console.log("message:::::"+message.search(/consumption/i)+"::::"+message.search(/history/i));
  if(message.search(/bill/i)>=0)
    {
      this.fetchAnimation(this.fetchMsg.bill)
    }
  else if(message.search(/payment/i)>=0)
   {
      this.fetchAnimation(this.fetchMsg.payment)
    }
    else if(message.search(/prepaid balance/i)>=0)
   {
      this.fetchAnimation(this.fetchMsg.balance)
    }
    else if(message.search(/recharge/i)>=0)
   {
      this.fetchAnimation(this.fetchMsg.recharge)
    }
    else if(message.search(/statement/i)>=0)
   {
      this.fetchAnimation(this.fetchMsg.statement)
    }
    else if((message.search(/consumption/i)>=0) && (message.search(/history/i)>=0))
   {
      this.fetchAnimation(this.fetchMsg.consumptionHistory)
    }
    else if((message.search(/balance history/i)>=0))
   {
      this.fetchAnimation(this.fetchMsg.balanceHistory)
    }
    else
    {
      this.fetchAnimation(this.fetchMsg.defaultMsg)
    }
  
  var parent = this;
    //showing the bot typing 
  setTimeout(function() {
  axios.request(config)
  .then((response) => {
    console.log((response.data));
    
    d = new Date();
    dateTime = d.toString().split("GMT")[0];
  if(response.data.status=="success" && response.data.responseType=="botResponse" )
  {
    parent.messages.push({
        from: 'Apdcl',
        data: "<span style='color: #df5d00;font-size:1rem'>"+message+" : "+response.data.msg+"</span>",
        time:dateTime 
      });
      
      // parent.messages.push({
      //   from: 'Apdcl',
      //   data: "<button class='btn btn-outline-danger' style='margin-top: 5px !important;border-radius: 25px !important; ' onclick='backToMenu()'>Back to Menu</button>", 
      // });

   
  }
  
  else if(response.data.status=="success" && response.data.responseType=="link" )
  {
    var msg=" <a target='_blank' href='"+response.data.msg+"' style=' color: #df5d00 !important;font-weight:500 !important;'><img src='https://www.apdcl.org/website/assets/pdf-icon-3.png' height='30px' width='30px' />Click here to "+message+"</a>";
      parent.messages.push({
        from: 'Apdcl',
        data: msg, 
        time:dateTime
      });
  }
  else if(response.data.status=="success" && response.data.responseType=="graph" )
  {
  console.log("this-currentMessage::::"+message);
    var data = response.data.msg;
    var label ="";
          var msg='<div id="GraphContainer'+i+'"><canvas id="consumptionChart'+i+'"></canvas></div>';
         
          parent.messages.push({
              from: 'Apdcl',
              data: msg, 
              time:dateTime
            });
          if(message=="Consumption history")
            {
              label="Consumption";
            }
            if(message=="Balance history")
            {
              label="Balance";
            }
          setTimeout(function() {displayGraph(data,label)}, 10);
  }

  else if(response.data.status=="fail" && response.data.otpGenerated=="N" )
  {
    parent.messages.push({
        from: 'Apdcl',
        data:response.data.error, 
        time:dateTime
      });
  }
  //parent.messages.push(parent.menu);
      parent.$nextTick(() => {parent.$refs.chatbox.scrollTop = parent.$refs.chatbox.scrollHeight;});
    })
    .catch((error) => {
      console.log(error);
      parent.hideTypingIndicator();
    });
  },2000)

    this.currentMessage='';
    this.$nextTick(() => {this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;});
  },
   
  displayGraph(data,lb)
  {
    var chartData = [];
    var chartLabel = [];
    
    var bgColor = ['#ffab91','#ff8a65','#ff7043','#ff5722','#e64a19','#d84315','#d84315'];
    if(lb=="Balance")
    {
      bgColor = ['#a5d6a7','#81c784','#66bb6a','#4caf50','#43a047','#388e3c','#2e7d32'];
    }
      // var canvas = document.createElement("canvas");
    // canvas.id = "consumptionChart";
    // document.getElementById("GraphContainer").appendChild(canvas);

    var res = data.split(','); 
    res.forEach(element => {
      console.log(element);
      var el = element.split(':');
     // console.log("Date"+el[0]);
      
      chartData.push(parseFloat(el[1]));
      chartLabel.push(el[0]);
    })
    console.log("chartData:"+chartData);
    console.log("chartLabel:"+chartLabel);
   
    var ctx = document.getElementById('consumptionChart'+i);
    i++;
    console.log("i = "+i);
    var myChart = new Chart(ctx, {
      type: 'bar',
      data: {
      labels: chartLabel,
      datasets: [
        {
            label	: lb,
            fill: true,
            backgroundColor: bgColor,
            data: chartData
        }
    ]
  } ,

  options: {
       responsive: true,
       lineTension: 1,
       scales: {
         yAxes: [{
           ticks: {
             beginAtZero: true,
             padding: 25,
           }
         }]
       }
     }
   });
     
 
}
  
},
  created(){ 
    window.getResponse=this.getResponse;
    window.backToMenu=this.backToMenu;
    window.displayGraph= this.displayGraph;
  },
  
  
};
</script>

<style scoped>
/* @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap'); */

#chatIcon
{
  height: 70px;
  transition: all 0.5s;
  position: fixed;
bottom: 24px;
right: 24px;
height: 60px;
width: 60px;
cursor: pointer;
border-radius: 50%;
box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
transition: transform 0.3s ease;
z-index: 9999;
}
#chatIcon:hover
{
  height: 80px;
  cursor:pointer;
  transition: all 0.5s;
}

.apdclbot-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: contain;
}

.chatbox-container {
  position: fixed;
  width: 100%;
  max-width: 400px;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
}

.container {
  padding-left: 0;
  padding-right: 0;
  width: 100%;
  max-width: 400px;
  height: 450px;
  max-height: 0px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: 'Roboto', sans-serif;
  /*-webkit-transition:height 0.8s;
  transition: transform 2s ease-in-out;*/
  transition: max-height 0.4s ease-in-out, opacity 0.3s ease;
}
.container.is-open {
  max-height: 500px;
  opacity: 1;
}

#chat-button {
  font-size: 1.1rem;
  width: 100%;
  
  font-weight: 600;
  text-align: center;
  color: #ffffff;
  padding: 10px;
  margin: 0;
  background-color: #1b61d1;
  border-bottom: 1px solid #e7e7e7;
}
.timeClass{
  font-size: 0.7rem;
  font-style: italic;
  color:#939495;
  text-align: left;
  padding-left:10px;
}
.chat-bar-collapsible {
    position: fixed;
    bottom: 0;
    right: 50px;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.collapsible {
    background-color: rgb(82, 151, 255);
    color: white;
    cursor: pointer;
    padding: 18px;
    width: 500px;
    text-align: left;
    outline: none;
    font-size: 18px;
    border-radius: 10px 10px 0px 0px;
    /* border: 3px solid white; */
    border-bottom: none;
}




/*  MESSAGE BOX */


.messageBox {
  padding: 16px;
  flex-grow: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.messageFromUser{
    display: flex;
    float:right;
}
.messageFromApdcl {
  display: flex; 
  float:left;
}



.messageBox {
  /* max-height: 470px; */
  overflow-y: auto;
  padding: 0 16px;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  flex-grow: 1;
  background-color: #d9d9d942;
}

.messageFromUser,
.messageFromApdcl {
  display: flex;
  margin-bottom: 8px;
}

.userMessageWrapper,
.ApdclMessageWrapper {
  display: flex;
  flex-direction: column;
}

.userMessageWrapper {
  align-self: flex-end;
}

.ApdclMessageWrapper {
  align-self: flex-start;
}

.userMessageContent{
    
  max-width: 100%;
  padding: 8px 12px;
  border-radius: 18px;
  margin-bottom: 2px;
  font-size: 14px;
  line-height: 1.4;
  text-align:right;
}
.ApdclMessageContent {
  max-width: 100%;
  padding: 8px 12px;
  border-radius: 18px;
  margin-bottom: 2px;
  font-size: 14px;
  line-height: 1.4;
  text-align:LEFT;
}

.userMessageContent {
  background-color: #1877F2;
  color: white;
  border-top-right-radius: 0;
}

.ApdclMessageContent {
  background-color: #ffffff;
  color: #222;
  border-top-left-radius: 0;
  box-shadow: grey 1px 1px 5px 0px;

}

.userMessageTimestamp,
.ApdclMessageTimestamp {
  font-size: 10px;
  color: #999;
  margin-top: 2px;
}

.userMessageTimestamp {
  align-self: flex-end;
}

.ApdclMessageTimestamp {
  align-self: flex-start;
}

.inputContainer {
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: #70b1e6;
}

.messageInput {
  flex-grow: 1;
  border: none;
  outline: none;
  padding: 12px;
  font-size: 16px;
  background-color: white;
  border-radius: 24px;
  margin-right: 8px;
}

.askButton {
  background-color: #1877F2;
  color: white;
  font-size: 16px;
  padding: 8px 16px;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 24px;
  transition: background-color 0.3s ease-in-out;
}

.askButton:hover {
  background-color: #145CB3;
}

.userAvatar,
.apdclAvatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #d3e3fd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  color: #1877F2;
}


.apdclAvatar {
  background-color: #f3f3f3;
  color: #222;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
}



  /* RESPONSIVE DESIGN */
@media (max-width: 768px) {
  .chatbox-container {
    right: 16px;
    left: 16px;
    bottom: 16px;
    
  }

  .container {
    width: 100%;
    height: 80vh;
    border-radius: 12px;
  }

  .collapsible {
    width: 100%;
    font-size: 16px;
  }

  .messageBox {
    padding: 12px;
  }

  .askButton {
    font-size: 14px;
    padding: 8px 12px;
  }
}
@media (max-width: 480px) {
  .container {
    height: 90vh;
    border-radius: 0;
  }
 
  .askButton,
  .messageInput {
    font-size: 14px;
    padding: 8px 12px;
  }
  
  .messageFromUser,
.messageFromApdcl {
  display: flex;
}

}














</style>